<template>
	<b-input-group>
			<b-form-select ref="hourPicker" class="text-center" :options="hourOptions" v-model="hour"></b-form-select>
			<b-input-group-prepend is-text>:</b-input-group-prepend>
			<b-form-select ref="minutePicker"  class="text-center"  :options="minuteOptions" v-model="minute" ></b-form-select>
			<!-- <b-form-select ref="meridiemPicker"  class="text-center"  :options="meridiemOptions" v-model="meridiem"></b-form-select> -->
	</b-input-group>
</template>
<script>
import moment from 'moment-timezone';

const TIMEZONE = 'America/Winnipeg';

export default {
	props: ['value'],
	data() {
		return {
			hour:null,
			minute:null,
            initializing: false
        };
	},
	computed: {

		hourOptions() {
            return Array.from({ length: 24 }, (_, i) => ({
                value: String(i),
                text: String(i).padStart(2, '0')
            }));
		},
		minuteOptions() {
            return Array.from({ length: 60 }, (_, i) => ({
                value: String(i).padStart(2, '0'),
                text: String(i).padStart(2, '0')
            }));
		}
    },

    watch: {
        value() {
            this.initializeTime();
        },

        hour() {
            if (!this.initializing) this.updateTime();
	},

        minute() {
            if (!this.initializing) this.updateTime();
		}
	},
	mounted() {
        this.initializeTime();
    },

	methods: {
        initializeTime() {
            this.initializing = true;

            if (this.value) {
                const local = moment.utc(this.value).tz(TIMEZONE);

                this.hour = local.format('H');
                this.minute = local.format('mm');
			} else {
                this.hour = null;
                this.minute = null;
			}

            this.$nextTick(() => {
                this.initializing = false;
            });
        },

        updateTime() {
            if (this.initializing || this.hour == null || this.minute == null) {
                return;
				}

            const local = this.value
                ? moment.utc(this.value).tz(TIMEZONE)
                : moment.tz(TIMEZONE);

            console.log("updateTime input:", this.value);
            console.log("updateTime local before:", local.format());

            local.hour(parseInt(this.hour, 10));
            local.minute(parseInt(this.minute, 10));
            local.second(0);
            local.millisecond(0);

            const utc = local.utc().format();

            console.log("updateTime", utc);

            this.$emit('update:time', utc);
            this.$emit('input', utc);
        }
	}
};
</script>
